import { render, staticRenderFns } from "./FormTutorat.vue?vue&type=template&id=28ba4c2a&"
import script from "./FormTutorat.vue?vue&type=script&lang=js&"
export * from "./FormTutorat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports